import { Box, Button, Flex, Link, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { OneVehicleIdentificationDto, VehiclesIdentificationDto, VehicleValuationDto } from 'brokertslib/src/dtos/VinOnline'
import { VehicleValuationModel } from 'brokertslib/src/hooks'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useVehicleValuation } from "../hooks/useVehicle"
import { formatDate } from '../utils/formatDate'

import { formatPrice } from 'BrokerTsLib/src/Utils/formatPrice'
import { Card, CardBody } from './Card'

interface VehicleEvaluationProps {
  vehiclesIdentification: VehiclesIdentificationDto
  onApplyEvaluation: ({ price, withTax }: { price?: number; withTax?: boolean }) => void
}

export const VehicleEvaluation = ({
  vehiclesIdentification,
  onApplyEvaluation,
}: VehicleEvaluationProps) => {

  var methods = useFormContext<InsuranceParamsDto>()

  const getValuationParams = (selectedVehicle: OneVehicleIdentificationDto): VehicleValuationModel => {
    const vehicle = methods.getValues('vehicle')
    const generalParams = methods.getValues('generalParams')

    return {
      paramsId: generalParams.paramsId?.toString(),
      licensePlate: vehicle.licensePlate ?? '',
      vin: vehicle.vin ?? '',
      vehicleId: selectedVehicle?.id ?? '',
      firstRegistrationDate: vehicle.firstRegistrationDate!,
      accSelected: selectedVehicle?.accessoriesOptionalSelected,
      mileage: vehicle.mileage
    }
  }

  const [vehicleValuation, setVehicleValuation] = useState<VehicleValuationDto | null>(null);

  const { mutateAsync: refetchValuation, isLoading: isLoadingValuation } = useVehicleValuation()

  const valuationError = !!vehicleValuation?.error

  return (
    <Box sx={{ display: 'grid', gap: 4, mt: 3 }}>
      <Table variant="striped" sx={{ fontSize: 'sm' }}>
        <Thead>
          <Tr>
            <Th>Popis</Th>
            <Th>V prodeji od</Th>
            <Th>V prodeji do</Th>
            <Th>Cena nového včetně DPH</Th>
          </Tr>
        </Thead>

        <Tbody>
          {vehiclesIdentification && vehiclesIdentification.vehicles && vehiclesIdentification.vehicles.length > 0 && vehiclesIdentification.vehicles?.map(vehicle =>
          (
            <Tr key={vehicle.id}>
              <Td>
                <Text>
                  {vehicle.description}
                  {' '}
                  {vehicle.pdfLink && (
                    <Link variant="underline" href={vehicle.pdfLink} target="_blank">
                      PDF
                    </Link>
                  )}
                </Text>
              </Td>
              <Td>
                {typeof vehicle.saleFrom === 'string'
                  ? vehicle.saleFrom
                  : formatDate({ date: vehicle.saleFrom as Date })}
              </Td>
              <Td>
                {typeof vehicle.saleTo === 'string'
                  ? vehicle.saleTo
                  : formatDate({ date: vehicle.saleTo as Date })}
              </Td>
              <Td>
                <Flex sx={{ flexWrap: 'wrap', gap: 4, placeItems: 'center' }}>
                  {vehicle.priceWithEquipment && <Text>{formatPrice({ price: vehicle.priceWithEquipment })}</Text>}

                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    isLoading={isLoadingValuation}
                    onClick={() => {
                      //setSelectedVehicle(vehicle)
                      refetchValuation(getValuationParams(vehicle))
                        .then(({ data }) => setVehicleValuation(data))
                    }}
                  >
                    Ocenit
                  </Button>
                </Flex>
              </Td>
            </Tr>
          )
          )}
        </Tbody>
      </Table>

      {
        vehicleValuation && (
          <Card sx={{ fontSize: 'sm' }}>
            <CardBody sx={{ p: 4 }}>
              <Flex sx={{ placeItems: 'center', placeContent: 'space-between' }}>
                {!valuationError &&
                  <>
                    <Text as="span">Obvyklá cena ojetého vozidla</Text>

                    <Flex sx={{ flexWrap: 'wrap', gap: 2 }}>
                      <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        colorScheme="blue"
                        onClick={() => onApplyEvaluation({ price: vehicleValuation.vehicleMarketPrice, withTax: false })}
                      >
                        <Text as="span" sx={{ fontWeight: 'bold' }}>
                          {formatPrice({ price: vehicleValuation.vehicleMarketPrice })}
                        </Text>
                        bez DPH
                      </Button>

                      <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        colorScheme="green"
                        onClick={() => onApplyEvaluation({ price: vehicleValuation.vehicleMarketPriceWithTax, withTax: true })}
                      >
                        <Text as="span" sx={{ fontWeight: 'bold' }}>
                          {formatPrice({ price: vehicleValuation.vehicleMarketPriceWithTax })}
                        </Text>
                        s DPH
                      </Button>
                    </Flex>
                  </>
                }
                {valuationError &&
                  <Text as="span">{vehicleValuation.error}</Text>
                }
              </Flex>
            </CardBody>
          </Card>
        )
      }
    </Box >
  )
}
